import { DataResult, DataStream, WidgetSettingsType } from '@thingslog/repositories';
import { formatValueWithUnit } from '../metadata';
import { DataResultParsed, DataResultParseStream } from '../DataResultParsed';
import { DataResultParseStrategy } from './DataResultParseStrategy';
import { t } from 'i18next';

interface ApiHistogramDataResultParseStrategyProps {
  color: string;
}

export class ApiHistogramDataResultParseStrategy implements DataResultParseStrategy {
  private color: string;

  public constructor(props: ApiHistogramDataResultParseStrategyProps) {
    this.color = props.color;
  }

  public parse(dataResult: DataResult, widgetType: WidgetSettingsType): DataResultParsed {
    const parsed: DataResultParsed = {
      dataStreams: [],
      xAxis: {
        show: true,
        dataKey: 'binLabel',
        name: t('dashboard_level', 'Level'),
        formatter: (value: string) => value,
      },
      yAxis: {
        show: true,
        name: t('devices', 'Devices'),
        formatter: (value: number) => value.toLocaleString(),
      },
      legend: {
        show: true,
      },
      tooltip: {
        formatter: (value: number | string, name: string): [string, string] => [
          formatValueWithUnit(value, ''),
          name,
        ],
        labelFormatter: (value: string | number): string => String(value),
      },
    };

    const dataStream: DataResultParseStream = {
      data: [],
      visualization: [
        {
          dataKey: 'devices',
          fill: this.color,
          innerRadius: 56,
          outerRadius: 86,
          name: t('devices', 'Devices'),
          nameKey: 'binLabel',
        },
      ],
    };

    dataResult.streams.forEach((stream: DataStream) => {
      if (stream.type !== 'series' || stream.data.length !== 1) {
        return;
      }

      const devices = stream.data[0];

      if (!Number.isFinite(devices)) {
        return;
      }

      dataStream.data.push({
        ...stream.metaData,
        binLabel: stream.metaData.binLabel ?? `${stream.metaData.edge}%`,
        devices,
      });
    });

    parsed.dataStreams.push(dataStream);

    return parsed;
  }
}
